module.exports = __webpack_public_path__ + "static/media/caution.2bda164e.svg";